"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.DropdownMenu = void 0;
var _dropdownMenu = require("./dropdownMenu");
exports.PLUGIN_KEY = _dropdownMenu.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _dropdownMenu.PLUGIN_PRIORITY;
exports.DropdownMenu = _dropdownMenu.DropdownMenu;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/dropdownMenu/index.js
// module id = 1349
// module chunks = 0